module.exports = "/_next/static/images/hide-f65c6efa818a64ac16252bce1e003fa2.svg";